export const blockIconsHardwareKeyboardArrowUp = (
	<span className='material-symbols-outlined'>keyboard_arrow_up</span>
);
